type IconProps = {
  style?: React.CSSProperties;
};

export const CheckIcon = ({ style = {} }: IconProps) => {
  return (
    <img src="/assets/icons/check-icon.svg" alt="Checked" style={{ height: '2.4rem', ...style }} />
  );
};
